import styled from "@emotion/native";
import { useSafeAreaFrame } from "react-native-safe-area-context";
import Text from "../Text";

export const Container = styled.TouchableOpacity(
    {
        marginBottom: 35,
    },
    ({ marginBottom }: any) => {
        return {
            marginBottom,
        };
    },
);

export const Hero = styled.Image(
    {
        resizeMode: "cover",
        margin: 0,
        left: 0,
        right: 0,
        width: "100%",
        height: 250,
    },
    () => {
        const frame = useSafeAreaFrame();
        return {
            width: frame.width,
        };
    },
);

export const Tile = styled.View(
    {
        flexGrow: 0,
        marginLeft: 72,
        marginTop: -46,
        marginRight: 13,
        paddingHorizontal: 12,
        paddingTop: 6,
        paddingBottom: 7,
        justifyContent: "flex-start",
    },
    ({ theme }: any) => {
        return {
            backgroundColor: theme.color.enabled,
        };
    },
);

export const Title = styled(Text)(
    {
        marginBottom: 7,
    },
    ({ theme }: any) => {
        return {
            color: theme.color.ctaText,
        };
    },
);

export const Tagline = styled(Text)({}, ({ theme }: any) => {
    return {
        color: theme.color.ctaText,
    };
});
